import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Test } from 'src/app/models/test.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from '../../services/auth-service/auth.service';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { UserDashboardService } from '../../user-dashboard.service';
import { UserBeforeTestMessageComponent } from '../../user-training/user-before-test-message/user-before-test-message.component';

@Component({
    selector: 'app-user-before-pre-test',
    templateUrl: './user-before-pre-test.component.html',
    styleUrls: ['./user-before-pre-test.component.scss'],
    standalone: false
})
export class UserBeforePreTestComponent implements OnInit {

  test: Test
  testSub: Subscription
  test$: Observable<Test>

  labels;
  labelsSub: Subscription;

  maxPoints: number
  user
  userSub: Subscription
  button1
  color
  constructor(
    private userDashboardService: UserDashboardService, private authService: AuthService, private languageService: UserLanguageService,
    private router: Router, private localStorageService:LocalStorageService) { }

  ngOnInit(): void {
    this.userSub = this.authService.user$.subscribe((user: User) => {
      this.user = user;
      setTimeout(() => {
        if(this.user.companyId == 1){
          this.button1 = "buttonEMS"
          this.color = "#49D14F"

        }else if(this.user.companyId == 2){
          this.button1 = "buttonECG"
          this.color = "#49D14F"
        }
        else{
          this.button1 = "buttonECG"
          this.color = "#49D14F"
        }
      }, 200);
    });

    this.userDashboardService.getPretestForTraining(this.localStorageService.getItem('pretestId'));

    this.testSub = this.userDashboardService.pretest$.subscribe((test) => {
      this.test = test;
      console.log("PRETEST: ", this.test)
      setTimeout(() => {
        this.maxPoints = 0
        this.test.questions.forEach(q =>{
          this.maxPoints+=q.points
        })
        console.log("TEST QUESTIONS LENGTH: ", this.test.questions.length)
      }, 250);
    })

    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }

  goToTestPage(){
    //window.location.reload()
    this.router.navigateByUrl("user/pretest");
  }

}
